import WorkspaceListContainer from 'components/feature/workspace/list/WorkspaceListContainer';

const WorkspaceListPage = () => {
  return <WorkspaceListContainer />;
};
export default WorkspaceListPage;
